export default "__VITE_ASSET__RRCW1f8s__"